"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core/styles");let b=a.makeStyles(a=>({container:{"&:hover":{"& path":{fill:a.palette.common.gray600,stroke:a.palette.common.gray600}},height:16,width:16}}));exports.default=b
//# sourceMappingURL=styles.js.map
